import type { MatrixEvent } from 'matrix-js-sdk';
import { useSyncExternalStore } from 'react';
import { roomTimelineStoreManager } from '../stores/RoomTimelineStore';

const emptyArray: MatrixEvent[] = [];

// Fallback-Funktionen für wenn kein Store verfügbar ist
const noopSubscribe = () => () => {
  /* noop */
};
const noopGetSnapshot = () => emptyArray;

/**
 * Hook zum Abrufen der Timeline eines Matrix Rooms.
 * Reaktiv - löst Re-Renders aus, wenn sich die Timeline ändert.
 *
 * @param roomId - Die ID des Rooms
 * @returns Array von MatrixEvent-Objekten
 */
export function useRoomTimeline(roomId: string): MatrixEvent[] {
  const store = roomTimelineStoreManager.getStore(roomId);

  // Hook muss immer aufgerufen werden - verwende Fallback wenn kein Store
  return useSyncExternalStore(
    store?.subscribe ?? noopSubscribe,
    store?.getSnapshot ?? noopGetSnapshot,
    () => emptyArray,
  );
}
